export default __webpack_public_path__ + "static/media/product8.f1fd90f9.png";